import { Box, CircularProgress, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

const TOTAL_SECONDS = 5 * 60

const Timer = () => {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS)
  const [isRunning, setIsRunning] = useState(false)

  useEffect(() => {
    if (!isRunning) return
    if (secondsLeft <= 0) {
      setIsRunning(false)
      return
    }

    const interval = setInterval(() => {
      setSecondsLeft((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(interval)
  }, [isRunning, secondsLeft])

  const handleClick = () => {
    if (secondsLeft === 0) {
      setSecondsLeft(TOTAL_SECONDS)
    }
    setIsRunning((prev) => !prev)
  }

  const minutes = Math.floor(secondsLeft / 60)
  const seconds = secondsLeft % 60

  const formattedTime = isRunning ? `${minutes}:${seconds
    .toString()
    .padStart(2, '0')}` : 'Avvia timer'

  const progress = (secondsLeft / TOTAL_SECONDS) * 100

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        position="relative"
        display="inline-flex"
        onClick={handleClick}
        sx={{ cursor: 'pointer' }}
      >
        <CircularProgress
          variant="determinate"
          value={progress}
          size={200}
          thickness={4}
        />

        <Box
          position="absolute"
          top={0}
          left={0}
          bottom={0}
          right={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="h4">{formattedTime}</Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default Timer